'use client';
import FullWidthSection from '@/components/full-width-section';
import Pagination from '@/components/pagination';
import PoliceLineDivider from '@/components/police-line-divider';
import { BlogListContainer } from '@/hooks/use-blog-board';
import { BLOG_LIST_LIMIT } from '@/lib/blog-list';
import { useBlogTopArticleList } from '@/services/query/article.query';
import BlogCard from './components/blog-card';
import BlogHeader from './components/blog-header';

// 블로그
export default function Client() {
  const { data: topData } = useBlogTopArticleList();
  const topList = topData?.data ?? [];

  return (
    <>
      <FullWidthSection className="bg-bg-grayblue px-6">
        <section className="desktop:flex desktop:justify-center">
          <div className="desktop:w-full desktop:web-w">
            <div className="desktop:typo-36 text-level-2 typo-24 desktop:pb-10 pb-6 font-extrabold">
              <span className="text-font-blue">신규게시물</span>이 등록되었어요.
            </div>
            <div className="desktop:w-full desktop:web-w">
              <div className="desktop:grid-cols-3 desktop:mb-[90px] mb-13 grid grid-cols-1 gap-x-8 gap-y-10">
                {topList?.map((item) => (
                  <div key={item.id}>
                    <BlogHeader {...item} />
                  </div>
                ))}
              </div>

              <PoliceLineDivider />
            </div>
          </div>
        </section>
      </FullWidthSection>

      <BlogListContainer
        limit={BLOG_LIST_LIMIT}
        render={({ items, page, totalPages, onPageChange }) => {
          return (
            <>
              <div className="desktop:typo-36 text-level-2 typo-24 desktop:pb-12 desktop:pt-20 pt-[57px] pb-6 font-extrabold">
                인기 콘텐츠 모음
              </div>
              <div className="desktop:gap-9 flex flex-col gap-5">
                {items.map((item) => (
                  <BlogCard {...item} key={item.id} />
                ))}
              </div>
              <Pagination
                page={page}
                totalPages={totalPages}
                onPageChange={onPageChange}
              />
            </>
          );
        }}
      />
    </>
  );
}
